import { motion, AnimatePresence } from 'framer-motion';
import Button from '@/components/ui/Button';

export default function MissionCompleteModal({ data, onClose }) {
  return (
    <AnimatePresence>
      {data && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-end justify-center"
          style={{ background: 'rgb(var(--hc-bg) / 0.9)' }}
        >
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 20, stiffness: 200 }}
            className="parchment-card relative w-full max-w-sm rounded-b-none rounded-t-3xl p-5"
          >
            <div className="text-center">
              <div className="mb-2 text-5xl">🎯</div>
              <h2 className="font-urban text-xl font-bold text-fg">Missão concluída!</h2>
              <p className="mb-4 mt-1 text-sm text-fg/70">{data?.title}</p>

              <div className="mb-5 flex justify-center gap-5 text-fg">
                <span className="font-serif font-bold">🪙 +{data?.coinReward || 0}</span>
                <span className="font-serif font-bold">⭐ +{data?.xpReward || 0} XP</span>
              </div>

              <Button variant="green" fullWidth onClick={onClose}>
                Continuar
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
